// Column layout for checklists submitted against the pre-2026 revision.
//
// Those records hold item keys the current columns no longer have, so they
// cannot be exported against CHECKLIST_HEADERS without coming out mostly
// blank. This pairs the frozen v1 item lists with the shared meta columns so
// the old records stay exportable in full, exactly as they were.
/* eslint-disable @typescript-eslint/no-explicit-any */
import { buildChecklistHeaders, flattenChecklistWith, } from "./checklistColumns.js";
import { NEW_CHECKLIST_SECTIONS_V1 } from "./checklistFieldsV1.js";
export const CHECKLIST_HEADERS_V1 = buildChecklistHeaders(NEW_CHECKLIST_SECTIONS_V1);
export function flattenChecklistV1(c) {
    return flattenChecklistWith(NEW_CHECKLIST_SECTIONS_V1, c);
}
//# sourceMappingURL=checklistColumnsV1.js.map